// import { lazy } from "react";
// import Loadable from "components/Loadable.tsx";

// const MemberTypewiseSectionConfigList = Loadable(lazy(() => import("features/memberTypewiseSectionConfig/components/List")));
// const MemberTypewiseSectionConfigPage = Loadable(lazy(() => import("features/memberTypewiseSectionConfig/components/Page")));

import MemberTypewiseSectionConfigList from './components/List'
import MemberTypewiseSectionConfigPage from './components/Page.tsx'

const routes = {
    path: 'memberTypewiseSectionConfig',
    children: [
        { path: '', element: <MemberTypewiseSectionConfigList /> },
        { path: 'add', element: <MemberTypewiseSectionConfigPage /> },
        { path: 'edit/:memberTypewiseSectionConfigID?', 
          element: <MemberTypewiseSectionConfigPage /> },
          
    ]
};

export default routes;